import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAllTegs,
  getChatQaProjects,
  getChatQaRandom,
  getChatqaResultStatistics,
  getLiveChatAgent,
  getLiveChatAgentId,
  getQaInfoByAgent,
  getQaInfoByAgentChats,
  patchQaChatCheked,
  patchQaChatChekedResult,
  getQaGroups,
  getQaGroupDetails,
  deleteQaGroupAgent,
  getFreeAgents,
  applyGroupAutomation,
  createQaGroup,
  getQaGroupHeads,
  addAgentToGroup,
  updateQaGroup,
  deleteQaGroup,
} from 'services/API';

export const getLiveChatAgentThunk = createAsyncThunk(
  'livechat/chats',
  async (
    {
      token,
      page,
      selectedColor,
      selectedStatus,
      searchId,
      searchThreadId,
      isAfterDate,
      searchUser,
      isBeforeDate,
      project,
      group,
      checked,
    },
    thunkAPI
  ) => {
    try {
      const response = await getLiveChatAgent(
        token,
        page,
        selectedColor,
        selectedStatus,
        searchId,
        searchThreadId,
        isAfterDate,
        searchUser,
        isBeforeDate,
        project,
        group,
        checked
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getLiveChatAgentIdThunk = createAsyncThunk(
  'livechat/agent',
  async ({ token, id }, thunkAPI) => {
    try {
      const response = await getLiveChatAgentId(token, id);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const patchQaChatChekedThunk = createAsyncThunk(
  'qa/changeChecked',
  async ({ token, formData, id }, thunkAPI) => {
    try {
      const response = await patchQaChatCheked(token, formData, id);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const patchQaChatChekedResultThunk = createAsyncThunk(
  'qa/changeCheckedResult',
  async ({ token, formData }, thunkAPI) => {
    try {
      const response = await patchQaChatChekedResult(token, formData);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getChatqaResultStatisticsThunk = createAsyncThunk(
  'qa/resultStatistics',
  async ({ token, year, month, group, reload, checked, group_id }, thunkAPI) => {
    try {
      const response = await getChatqaResultStatistics(
        token,
        year,
        month,
        reload,
        group,
        checked,
        group_id
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getAllTegsThunk = createAsyncThunk(
  'qa/allTegs',
  async ({ token, question }, thunkAPI) => {
    try {
      const response = await getAllTegs(token, question);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getQaInfoByAgentThunk = createAsyncThunk(
  'qa/geiInfoByAgent',
  async ({ token, id, created_at_after, created_at_before }, thunkAPI) => {
    try {
      const response = await getQaInfoByAgent(
        token,
        id,
        created_at_after,
        created_at_before
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getQaInfoByAgentChatsThunk = createAsyncThunk(
  'qa/getInfoByAgentChats',
  async (
    { token, id, page, created_at_after, created_at_before },
    thunkAPI
  ) => {
    try {
      const response = await getQaInfoByAgentChats(
        token,
        id,
        page,
        created_at_after,
        created_at_before
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getChatQaRandomThunk = createAsyncThunk(
  'qa/getChatQaRandom',
  async (
    { token, created_at_after, created_at_before },
    thunkAPI
  ) => {
    try {
      const response = await getChatQaRandom(
        token, created_at_after, created_at_before
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);


export const getChatQaProjectsThunk = createAsyncThunk(
  'qa/getChatQaProjects',
  async (
    { token},
    thunkAPI
  ) => {
    try {
      const response = await getChatQaProjects(
        token
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getQaGroupsThunk = createAsyncThunk(
  'qa/getQaGroups',
  async ({ token, head, month, year }, thunkAPI) => {
    try {
      const response = await getQaGroups(token, head, month, year);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getQaGroupDetailsThunk = createAsyncThunk(
  'qa/getQaGroupDetails',
  async ({ token, groupId }, thunkAPI) => {
    try {
      const response = await getQaGroupDetails(token, groupId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const deleteQaGroupAgentThunk = createAsyncThunk(
  'qa/deleteQaGroupAgent',
  async ({ token, groupId, agentId }, thunkAPI) => {
    try {
      const response = await deleteQaGroupAgent(token, groupId, agentId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const getFreeAgentsThunk = createAsyncThunk(
  'qa/getFreeAgents',
  async ({ token, freeAgent, lcid, name, yearMonth }, thunkAPI) => {
    try {
      const response = await getFreeAgents(token, freeAgent, lcid, name, yearMonth);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const applyGroupAutomationThunk = createAsyncThunk(
  'qa/applyGroupAutomation',
  async ({ token, force, missing }, thunkAPI) => {
    try {
      const response = await applyGroupAutomation(token, force, missing);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const createQaGroupThunk = createAsyncThunk(
  'qa/createQaGroup',
  async ({ token, groupData }, thunkAPI) => {
    try {
      const response = await createQaGroup(token, groupData);
      return response;
    } catch (e) {
      // Улучшенная обработка ошибок
      let errorMessage = 'Ошибка при создании группы';
      
      if (e.response && e.response.data) {
        // Если сервер вернул данные об ошибке
        if (typeof e.response.data === 'string') {
          errorMessage = e.response.data;
        } else if (e.response.data.message) {
          errorMessage = e.response.data.message;
        } else if (e.response.data.error) {
          errorMessage = e.response.data.error;
        } else if (e.response.data.detail) {
          errorMessage = e.response.data.detail;
        }
      } else if (e.message) {
        errorMessage = e.message;
      }
      
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getQaGroupHeadsThunk = createAsyncThunk(
  'qa/getQaGroupHeads',
  async ({ token, freeHead }, thunkAPI) => {
    try {
      const response = await getQaGroupHeads(token, freeHead);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const addAgentToGroupThunk = createAsyncThunk(
  'qa/addAgentToGroup',
  async ({ token, groupId, agentId }, thunkAPI) => {
    try {
      const response = await addAgentToGroup(token, groupId, agentId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const updateQaGroupThunk = createAsyncThunk(
  'qa/updateQaGroup',
  async ({ token, groupId, groupData }, thunkAPI) => {
    try {
      const response = await updateQaGroup(token, groupId, groupData);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);

export const deleteQaGroupThunk = createAsyncThunk(
  'qa/deleteQaGroup',
  async ({ token, groupId }, thunkAPI) => {
    try {
      const response = await deleteQaGroup(token, groupId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  }
);
